import * as React from 'react';

export interface SpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
}

const sizeClasses = {
  sm: 'h-4 w-4 border-2',
  md: 'h-6 w-6 border-2',
  lg: 'h-8 w-8 border-2',
};

export const Spinner = React.forwardRef<HTMLDivElement, SpinnerProps>(
  ({ size = 'md', className = '' }, ref) => (
    <div
      ref={ref}
      aria-label="Loading"
      role="status"
      className={`animate-spin rounded-full border-pink-500 border-t-transparent ${sizeClasses[size]} ${className}`}
    />
  ),
);
Spinner.displayName = 'Spinner';
